import { render, staticRenderFns } from "./AccountVideos.vue?vue&type=template&id=d920f828&"
import script from "./AccountVideos.vue?vue&type=script&lang=js&"
export * from "./AccountVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports